import type { HttpPost, HttpRequest } from '@/shared/infra/http'
import { mapServerError } from '@/shared/infra/http'
import type { ProPlanChangeResult } from '@/shared/domain'
import { PlanChangeAmountMismatchError } from '@/shared/domain'
import type { ChangeProPlan } from '@/modules/auth/use-cases'

export class EdgeChangeProPlanRepository {
  constructor(private readonly httpClient: HttpPost) {}

  execute: ChangeProPlan = async (params) => {
    const body = {
      targetPlan: params.targetPlan,
      ...(params.prorationDate !== undefined ? { prorationDate: params.prorationDate } : {}),
      ...(params.expectedAmountDueNow !== undefined
        ? { expectedAmountDueNow: params.expectedAmountDueNow }
        : {}),
      ...(params.source ? { source: params.source } : {}),
    }
    const request: HttpRequest<typeof body> = {
      url: '/pro-billing/plan-change',
      body,
    }
    try {
      return await this.httpClient.post<typeof body, ProPlanChangeResult>(request)
    } catch (err) {
      mapServerError(err, {
        '409:price changed since': PlanChangeAmountMismatchError,
      })
    }
  }
}
